import { useEffect } from "react";
import { Postdata } from "../API/GlobalApi";
import { formatDateDDMMYYYYHHMMSS } from "./data&dateTime";


const getCollegeTitle = (courseName) => {
  if (!courseName) return "Banaras Institute of Teachers Education";

  const name = courseName.toLowerCase();

  // check if includes “d pharm” or “d. pharm”
  if (name.includes("d pharm") || name.includes("d. pharm") || name.includes("dpharm")) {
    return "Banaras Institute of Pharmacy";
  }

  return "Banaras Institute of Teachers Education";
};



export const handlePrintReceipt = (row) => {
  const data = row.original; 
  // Determine parent info based on gender
  const parentInfo = data.student_gender === "Female"
    ? `D/O ${data.student_mother_name || "N/A"}`
    : `S/O ${data.student_father_name || "N/A"}`;

  const receiptHtml = `
    <html>
      <head>
        <title>Payment Receipt</title>
        <style>
          /* Print settings for POS 58mm printer */
          @media print {
            @page {
             size: 58mm auto;
            margin: 0;
            }
            body {
              margin: 0;
            padding: 0;
            width: 48mm;
            font-family: monospace;
            font-size: 11px;
            line-height: 1.3;

            }
          }

          body {
        width: 48mm;
            margin: 0 auto;
            font-family: monospace, sans-serif;
            font-size: 11px;
            line-height: 1.4;
            text-align: left;
            white-space: normal;
            word-break: keep-all;
            overflow-wrap: anywhere;
          }

          hr {
            border: 0;
            border-top: 1px dashed #000;
            margin: 1px 0;
          }

          p {
            margin: 1px 0;
            word-wrap: break-word;
            white-space: normal;
          }

          .bold {
            font-weight: bold;
          }
            
        .collegenameTitle, .affiliateTitle {
        display: block;
        font-size: 12px;
        font-weight: bold;
        text-align: start;
        word-break: break-word; /* allow wrapping */
      }
        </style>
      </head>
      <body>
        <!-- Header -->
      
      <h5 class="collegenameTitle" style="margin:0;">${getCollegeTitle(data.course_name)}</h5>

        <hr />
        <p class="bold" style="margin:0;">PAYMENT RECEIPT</p>
        <hr />

        <!-- Payment Details -->
        <p>Date: ${formatDateDDMMYYYYHHMMSS(data.payment_date)}</p>
        <p>Receipt #: ${data.transaction_id}</p>
        <hr />
        <p>${data.student_name}</p>
          <p>${parentInfo}</p>
        <p> ${data.permanent_registration_number}</p>
       <p style="word-wrap: break-word; white-space: normal;font-size:10px;">${data.course_name}</p>

        <hr />
        <p>Amount  : ₹${data.amount.toFixed(2)}</p>
        <p>Mode    : ${data.payment_method}${data.transaction_ref ? ` (Ref: ${data.transaction_ref})` : ''}</p>
        <hr />
      </body>
    </html>
  `;

  const printWindow = window.open("", "_blank", "width=400,height=500");
  printWindow.document.open();
  printWindow.document.write(receiptHtml);
  printWindow.document.close();

  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
};



export const handlePrintRemitanceReceipt = async (row, data) => {


  // Determine parent info based on gender
  const parentInfo = data.student_gender === "Female"
    ? `D/O ${data.mother_name || "N/A"}`
    : `S/O ${data.father_name || "N/A"}`;


  const receiptHtml = `
    <html>
      <head>
        <title>Payment Receipt</title>
        <style>
          /* Print settings for POS 58mm printer */
             @media print {
            @page {
             size: 58mm auto;
            margin: 0;
            }
            body {
              margin: 0;
            padding: 0;
            width: 48mm;
            font-family: monospace;
            font-size: 11px;
            line-height: 1.3;

            }
          }

          body {
         width: 48mm;
            margin: 0 auto;
            font-family: monospace, sans-serif;
            font-size: 11px;
            line-height: 1.4;
            text-align: left;
            white-space: normal;
            word-break: keep-all;
            overflow-wrap: anywhere;
          }

          hr {
            border: 0;
            border-top: 1px dashed #000;
            margin: 1px 0;
          }

          p {
            margin: 1px 0;
            word-wrap: break-word;
            white-space: normal;
          }

          .bold {
            font-weight: bold;
          }

        .collegenameTitle, .affiliateTitle {
        display: block;
        font-size: 12px;
        font-weight: bold;
        text-align: start;
        word-break: break-word; /* allow wrapping */
      }
        </style>
      </head>
      <body>
        <!-- Header -->

        <h5 class="collegenameTitle" style="margin:0;">Banaras Institute   of <br/> Teachers  Education</h5>
        <hr />
        <p class="bold" style="margin:0;">PAYMENT RECEIPT</p>
        <hr />

        <!-- Payment Details -->
        <p>Date: ${formatDateDDMMYYYYHHMMSS(data.payment_date)}</p>
        <p>Receipt #: ${data.transaction_id}</p>
        <hr />
        <p>${data.student_name}</p>
          <p>${parentInfo}</p>
        <p> ${data.registration_no}</p>
       <p style="word-wrap: break-word; white-space: normal;font-size:10px;">${data.course_name}</p>

        <hr />
        <p>Amount  : ₹${data.amount.toFixed(2)}</p>
        <p>Mode    : ${data.mode_of_payment}</p>
        <hr />
      </body>
    </html>
  `;

  const printWindow = window.open("", "_blank", "width=400,height=600");
  printWindow.document.open();
  printWindow.document.write(receiptHtml);
  printWindow.document.close();

  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
};
